export function contributorKey(item) {
  if (typeof item === 'string') return item;
  return item?.name_zh ?? '';
}

/** Sort contributor/club records by the Contributor.sequence field. */
export function sortContributorsBySequence(items) {
  return [...items].sort((a, b) => {
    const sa = typeof a === 'object' && a != null ? (a.sequence ?? 9999) : 9999;
    const sb = typeof b === 'object' && b != null ? (b.sequence ?? 9999) : 9999;
    if (sa !== sb) return sa - sb;
    return String(contributorKey(a)).localeCompare(
      String(contributorKey(b)),
      undefined,
      { sensitivity: 'base', numeric: true },
    );
  });
}
